


































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { CommunicationData } from "@/entities";

const namespace: string = "communication";

@Component({
  components: {
      ReportingPeriods: () => import('./ReportingPeriods/CommunicationPeriod.vue'),
      WorkflowJourney: () => import('@/components/common/ProgressBar/ParentChildProgressBar.vue'),
      WorkflowButtons: () => import('@/components/common/ProgressBar/WorkflowButtons.vue'),
      BackButton: () => import('@/components/common/Buttons/BackButton.vue')
  }
})
export default class CommunicationReportingPeriodsComponent extends Vue{

    @State(namespace) comm!: CommunicationData;
    @Action("getCommunication", { namespace }) getCommunication: any;
    @Action("saveCommunication", { namespace }) saveCommunication: any;
    @Action("startCommunication", { namespace }) startCommunication: any;
    @Action("showNotification", { namespace: 'application' }) notify: any;


    /** variables */
    isDirty: boolean = false;

    /** back to the dashboard */
    back() {
        this.$router.push({
            name: "Communication"
        });
    }

    /** save the communication */
    save() {
        this.saveCommunication(this.comm.communication);
    }

    /** update the workflow status */
    updateStatus(item: any) {
        if(this.comm.communication.Steps.filter(x => x.StepId && (!x.StartDate || !x.EndDate)).length > 0) {
            this.notify(
                {
                    text: 'Report Start Date or End Date cannot be blank.',
                    isHtml: true,
                    color: "error"
                }
            );
        } else {
            this.startCommunication({ 
                nextStepId: item.StepId, 
                data: this.comm.communication 
            });
        }
    }

    /** watch method to refresh page on page load */
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute: any) {
        if(changedRoute && changedRoute.name === 'communicationReportingPeriods') {

            const commId = changedRoute.params.communicationId;

            // Added this condition to hadle the route change on hash value update
            if(!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.communicationId !== previousRoute.params.communicationId ) {
                this.getCommunication(commId);
            }
        }
    }
    
}
